import React, { useState, useEffect } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Form, Button } from 'semantic-ui-react'
import FWOIteractiveTemplateRow from '../helpers/FWOIteractiveTemplateRow'
import {
  getInitialValues,
  getFields,
  getFieldSchema,
  buildAddressFromValues,
} from '../common'
import Accordion from '../../common/Accordion'
import {
  FormKey,
  IInteractiveTemplateField,
  IInteractiveTemplatePage,
  IInteractiveTemplateSection,
} from '../../../models/InteractiveTemplate'
import PageTitle from '../../PageTitle'

export const LetterOfResignationTemplate = ({
  show,
  setShow,
  template,
  handleNext,
}) => {
  const [initialValues, setInitialValues] = useState({})
  const [validationSchema, setValidationSchema] = useState(null)

  useEffect(() => {
    const schema = createYupSchema()
    setValidationSchema(schema)
  }, [])

  const createYupSchema = () => {
    setInitialValues(getInitialValues(template))
    const fields = getFields(template)

    const schema = fields.reduce((schema, field) => {
      return getFieldSchema(schema, field)
    }, {})
    return Yup.object().shape(schema)
  }

  const renderField = (field: IInteractiveTemplateField, index: number) => {
    return (
      <FWOIteractiveTemplateRow
        key={index}
        {...field}
      ></FWOIteractiveTemplateRow>
    )
  }

  const renderSection = (
    section: IInteractiveTemplateSection,
    index: number
  ) => {
    if (section?.fields) {
      return (
        <section key={index}>
          <h3>{section.name}</h3>
          {section.fields.map((field, index) => renderField(field, index))}
        </section>
      )
    } else {
      return <></>
    }
  }

  const renderPage = (page: IInteractiveTemplatePage, index: number) => {
    return (
      <Accordion
        key={index}
        heading={page.name}
        expanded={show}
        onClick={setShow}
      >
        {page.sections?.map((section, index) => renderSection(section, index))}
        <p className="form-submit">
          <Button className="ui is-primary button form-submit">Next</Button>
        </p>
      </Accordion>
    )
  }

  const onSubmit = (values) => {
    values['BUSINESS_ADDRESS'] = buildAddressFromValues(
      'BUSINESS_ADDRESS',
      values
    )

    setInitialValues(values)
    handleNext(values, FormKey.LetterOfResignation)
    setShow(false)
  }

  return (
    <>
      <PageTitle title="Letter of resignation - Templates - Fair Work Ombudsman" />
      <Formik
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={initialValues}
        validateOnMount={false}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <Form
            className="ui form osp-variant large"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <div className="accordian">
              {template?.pages?.map((page, index) => renderPage(page, index))}
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
